<template>
  <div id="dashboard">
    <div id="leftmenu">
      <div>
         <div id="userDec">
            <div id="profile-img">
              <img
                style="width: 64px;border-radius: 50%;height: 64px;"
                v-if="this.$store.getters.isAuthenticated && this.$store.state.userData && this.$store.state.userData.userProfilePic"
                :src="this.$store.state.userData.userProfilePic"
              />
              <img v-else src="../assets/svg/profiledark.svg" class="profileicon" />
            </div>
            <div id="user-name-parent">
              <span>
                <p class="head-profile">Hello,</p>
                <p
                  class="head-name"
                  v-if="this.$store.state.userData.orgname"
                >{{this.$store.state.userData.orgname}}</p>
                <p class="head-name" v-if="!this.$store.state.userData.orgname">User</p>
              </span>
                <span style="color:#4415e5">
                <a @click="()=>{this.$refs.inputFile.click()}">Change Profile Image</a>
              </span>
              <input
                style="visibility: hidden;position: absolute;"
                ref="inputFile"
                type="file"
                id="myFile"
                @change="uploadPic"
              />
            </div>
          </div>
        <div id="userDesMenu">
          <div class="mainDiv">
            <div @click="showProfile" class="active userOpt">
              <v-icon>person</v-icon>
              <div class="mainSel">ACCOUNT SETTINGS</div>
            </div>
            <div>
              <a @click="showProfile">
                <div class="subSel">Profile Information</div>
              </a>

              <a @click="showProfile">
                <div class="subSel">Company Information</div>
              </a>
            </div>
          </div>
          <div class="mainDiv">
            <div class="userOpt">
              <v-icon>reorder</v-icon>
              <a class="mainSel">Order</a>
            </div>
          </div>
          <div class="mainDiv">
            <div class="userOpt">
              <v-icon>favorite_border</v-icon>
              <a class="mainSel">My Wish List</a>
            </div>
          </div>
          <div class="mainDiv">
            <div class="userOpt">
              <v-icon>notifications_none</v-icon>
              <a class="mainSel">Notifications</a>
              <v-badge>
                <template v-slot:badge>
                  <span>{{notificationcount}}</span>
                </template>
              </v-badge>
            </div>
          </div>
          <div class="mainDiv">
            <div class="userOpt">
              <v-icon>help_outline</v-icon>
              <a class="mainSel">Help Center</a>
            </div>
          </div>
          <div class="mainDiv">
            <div class="userOpt">
              <v-icon>power_settings_new</v-icon>
              <a class="mainSel">Logout</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="rightmenu">
      <div>
        <div class="profileRightSide">
          <div>
            <p>Personal Information</p>
          </div>
          <div>
            <v-icon>edit</v-icon>
          </div>
        </div>

        <div id="sideEditName">
          <v-text-field label="First Name" single-line outline></v-text-field>
          <v-text-field label="Last Name" single-line outline></v-text-field>
        </div>
      </div>
      <div>
        <div class="profileRightSide">
          <p>Email Address</p>
          <v-icon>edit</v-icon>
        </div>

        <div id="sideEditEmail">
          <v-text-field label="Email Address" single-line outline></v-text-field>
        </div>
      </div>
      <div>
        <div class="profileRightSide">
          <p>Phone</p>
          <v-icon>edit</v-icon>
        </div>

        <div id="sideEditPhone">
          <v-text-field label="Phone" single-line outline></v-text-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "d",
  components: {},
  computed: {
    notificationcount() {
      let notifications = 0;
      this.$store.state.products.forEach(e => {
        if (e.readuser == 0 && e.uid == this.$store.state.uid) {
          notifications = notifications + 1;
        }
      });
      return notifications;
    }
  }
};
</script>
<style scoped>
.userNameHello {
  padding: 5px 0 0 16px;
}
.row {
  display: flex;
  flex-flow: row;
}
#sideEditName {
  display: flex;
  width: 100%;
  flex-flow: row;
}

#sideEditEmail {
  display: flex;
  width: 50%;
  flex-flow: row;
}

#sideEditPhone {
  display: flex;
  width: 50%;
  flex-flow: row;
}
#sideEditPhone div {
  margin-top: 5px;
  padding: 10px;
}
#sideEditEmail div {
  margin-top: 5px;
  padding: 10px;
}
#sideEditName div {
  margin-top: 5px;
  padding: 10px;
}
.subSel {
  font-size: 14px;
  padding: 12px 5px 12px 66px;
  cursor: pointer;
  font-weight: 500;
}

.subSel:hover {
  color: #2874f0;
  background-color: #f5faff;
}
.mainSel {
  padding: 0 0 12px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #878787;
}
.mainDiv {
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.userOpt {
  padding: 20px 12px 5px 24px;
  display: flex;
}
.row {
  flex-flow: row wrap;
  text-align: center;
}
#dashboard {
  display: flex;
  flex-flow: row wrap;
  margin: 0 auto;
  position: relative;
  justify-content: center;
  width: 90%;
  margin-top: 85px;
  margin-bottom: 20px;
}
#leftmenu {
  width: 25%;
}
#rightmenu {
  width: 65%;
  display: flex;
  flex-flow: column;
  background: white;
  /* border-radius: 10px; */
  margin-left: 15px;
  padding: 10px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
}

.profileRightSide {
  display: flex;
  flex-flow: row;
  margin: 0 auto;
}
.profileRightSide i {
  margin-left: 10px;
}

#profileRightSide p {
  font-size: 18px;
  font-weight: 500;
  padding-right: 24px;
}
#userMainDEC {
  display: flex;
  height: 6rem;
  background: white;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
  display: flex;
}
#userDec {
  display: flex;
  flex-direction: row;
  margin: auto;
}

#userDec img {
  margin-right: 10px;
}
#userDec p {
  margin-left: 10px;
  margin-bottom: 0;
}
#userDec p:nth-of-type(1) {
  margin-bottom: 5px;
}
#userDesMenu {
  margin-top: 15px;
  background: white;
  /* border-radius: 10px; */
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16), 0 3px 4px rgba(0, 0, 0, 0.23);
}
</style>


